import { useCircleAgreementStore } from '../stores/circle-agreement.store';
import { useEmpathyNormsStore } from '../stores/empathy-norms.store';
import { useUpgradePromptStore } from '../stores/upgrade-prompt.store';

/**
 * True while the API interceptor has a gate up (circle agreement, empathy
 * norms, upgrade prompt or the plan selector it opens). A sheet whose request is PARKED behind a gate is
 * not "sending": the user is answering the gate, so the sheet drops its
 * spinner and leaves its controls (and its Escape) to them (phone pass P7-1).
 */
export function useGateOpen(): boolean {
  const agreement = useCircleAgreementStore((s) => s.isOpen);
  const norms = useEmpathyNormsStore((s) => s.isOpen);
  // The plan selector "See plans" opens is the same gate, one screen on.
  const upgrade = useUpgradePromptStore((s) => s.open || s.plansOpen);
  return agreement || norms || upgrade;
}

/**
 * Close whichever gate is up, declining a parked request (it is then NOT
 * replayed). True when a gate was up, closed or not. Android's Back calls this
 * first (phone pass P5-1): Back over a gate answers the gate, as it would a
 * native dialog, instead of leaving the page that raised it. While the gate's
 * accept is in flight it holds (`dismiss` refuses) and Back is still consumed,
 * so the page behind stays put (backlog c-065).
 */
export function closeOpenGate(): boolean {
  const norms = useEmpathyNormsStore.getState();
  if (norms.isOpen) {
    norms.dismiss();
    return true;
  }
  const agreement = useCircleAgreementStore.getState();
  if (agreement.isOpen) {
    agreement.dismiss();
    return true;
  }
  const upgrade = useUpgradePromptStore.getState();
  if (upgrade.open || upgrade.plansOpen) {
    upgrade.closePlans();
    return true;
  }
  return false;
}
